import React, { useEffect, useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import { Checkbox, FormControlLabel } from "@mui/material";
import api from "../../api/api";

const FilterPopup = ({ isOpen, onClose, parentselectedstatus,parentprovider,parentchecked, setChecked,clearFilters, checked ,data, onStatusSelect,onProviderFilter}) => {
  const [tempChecked, setTempChecked] = useState(checked); 
  const [selectedStatus, setSelectedStatus] = useState(null); 
  const [selectedProvider, setSelectedProvider] = useState([]); 
     useEffect(()=>{
setSelectedStatus(parentselectedstatus)
setSelectedProvider(parentprovider)
setTempChecked(parentchecked)
    },[parentselectedstatus,parentprovider,parentchecked])
  // Handle checkbox change only in the temporary state
// Handle checkbox change only in the temporary state
const handleCheckboxChange = (event, name) => {
  setTempChecked((prev) => {
    const updatedChecked = {
      ...prev,
      [name]: event.target.checked,
    };

    return updatedChecked;
  });
};


  // Handle Status click (only for visual selection until apply is clicked)
  const handleStatusClick = (statusName) => {
    if (statusName === selectedStatus) {
      setSelectedStatus(null); // Deselect if it's already selected
    } else {
      setSelectedStatus(statusName); // Select the new status
    }
  };

  // Handle Provider click (only for visual selection until apply is clicked)
  const handleProviderClick = (providername) => {
    setSelectedProvider((prevSelectedProviders) => {
      if (prevSelectedProviders.includes(providername)) {
        // Deselect the provider if it's already selected
        return prevSelectedProviders.filter((provider) => provider !== providername);
      } else {
        // Add the provider to the selected array
        return [...prevSelectedProviders, providername];
      }
    });
  };
  

  // Apply filters by updating the actual checked state and status/provider
  const handleSelectAllChange = () => {

    setChecked(tempChecked); // Only update the main state when Apply Filters is clicked
    onStatusSelect(selectedStatus); // Pass selected status back to parent
    onProviderFilter(selectedProvider); // Pass selected provider back to parent
    onClose(); // Close the popup after applying the filter
  };

  // Clear all filters (reset selections)
  const handleClearFilters = () => {
    if (clearFilters) {
      clearFilters(); // Call the function to reset filters
      onClose(); // Close the popup after clearing the filters
    }
    setSelectedStatus(null); // Reset selected status
    setSelectedProvider([]); // Reset selected provider
    setTempChecked({
      ShowMR: false,
      ShowCancelled: false,
      ShowChecked: false,
      ShowAll: false,
    }); // Reset checkboxes
    setChecked({
      ShowMR: false,
      ShowCancelled: false,
      ShowChecked: false,
      ShowAll: false,
    }); // Reset main checkboxes state
  };

  return (
    isOpen && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto pt-10">
        {/* Popup Box */}
        <div className="relative flex flex-col gap-2 w-[386px] bg-white pb-2 p-3 rounded-lg shadow-lg text-left">
          <button
            className="absolute right-[3%] text-gray-500 hover:text-gray-700 text-[30px]"
            onClick={onClose}
          >
            <CloseIcon style={{ color: 'black', width: '15px' }} />
          </button>
          <div className="p-2">
            <div className="w-full flex items-center justify-between mt-2">
              {/* Title */}
              <span className="ml-2  font-inter text-[#1D2951] text-xs font-semibold text-center tracking-[0] leading-[normal] whitespace-nowrap">
                Status
              </span>
            </div>
          </div>

          <div className="flex flex-column">
  {[...new Set(data.map(x => x.visit_confirmation))] // Get unique visit_confirmation values
    .filter(status =>
      ["Ready for Checkout", "Ready for Provider", "Processing", "Ready for Triage","Checked Out"].includes(status) // Filter for specific statuses
    )
    .map((status, index) => {
      // Define the base button classes
      let buttonClass = "py-2 px-4 m-1 mr-3 text-xs font-inter ml-3 rounded-full transition";
      
      // Add the background color and text color based on the status
      if (status === "Ready for Triage") {
        buttonClass += " bg-[#F0FDF4] text-[#50869A]"; // Specific for "Ready for Triage"
      } else if (status === "Ready for Provider") {
        buttonClass += " bg-[#F3E8FF] text-[#9333EA]";
      } else if (status === "Checked Out") {
        buttonClass += " bg-[#E1795459] text-[#C2410C]";
      } else if (status === "Processing") {
        buttonClass += " bg-[#DBEAFE] text-[#1D4ED8]";
      } else if (status === "Ready for Checkout") {
        buttonClass += " bg-[#DBEAFE] text-[#1D4ED8]";
      } else {
        buttonClass += " bg-[#ECECEE] text-[#1D4ED8]"; // Default style
      }
      
      // Add a selected class for the selected status
      const selectedClass = selectedStatus === status ? "bg-[#DBEAFE] border-[1.5px] border-[#1D4ED8]" : "";
      
      return (
        <button
          key={index}
          onClick={() => handleStatusClick(status)}
          className={`${buttonClass} ${selectedClass}`}
        >
          {status} {/* Button text */}
        </button>
      );
    })
  }
           </div>


          <div className="px-3 text-xs font-inter font-semibold border-t pt-2">Provider</div>
          <div className="flex ml-3 flex-wrap">
            {[...new Set(data.map(x => x.linked_provider))] // Get unique linked_provider values
              .map((provider, index) => {
                // Add a selected class for the selected provider
                const selectedClass = selectedProvider.includes(provider)? "bg-[#E17954] text-white " : "";

                return (
                  <button
                    key={index}
                    onClick={() => handleProviderClick(provider)}
                    className={`inline-block  flex-wrap rounded-full py-1 px-2 text-[11px] w-[auto] font-inter text-[black] border-[1.5px]  mr-2 mb-2 ${selectedClass}`}
                  >
                    {provider} {/* Button text */}
                  </button>
                );
              })
            }
          </div>

          <div className="p-2 ml-2 border-b border-t">
            <div>Filter</div>
            {[ 
              { name: "ShowMR", label: "Show MR" },
              { name: "ShowCancelled", label: "Show Cancelled" },
              { name: "ShowChecked", label: "Show Checkedout" },
              { name: "ShowAll", label: "Show All" }
            ].map((item) => (
              <div className="w-full flex justify-between items-center" key={item.name}>
                <div className="flex items-center">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={tempChecked[item.name]} // Use the temporary state here
                        onChange={(e) => handleCheckboxChange(e, item.name)}
                        color="default"
                        sx={{
                          '.MuiSvgIcon-root': {
                            color: tempChecked[item.name] ? 'black' : '', // Orange color when selected
                          },
                        }}
                      />
                    }
                    label={item.label}
                    sx={{
                      '.MuiFormControlLabel-label': {
                        fontSize: '14px',
                        color: "#4B4B4B",
                        fontFamily: "sans-serif",
                      },
                    }}
                  />
                </div>
              </div>
            ))}
          </div>

          {/* Apply Filters Button */}
          <div className="w-full flex justify-end gap-6 mb-1 ">
            {/* Clear All Filters Button */}
            <button
              onClick={handleClearFilters}
              className="rounded py-2 text-[13px] font-inter px-2  transition duration-300 ease-in-out  border-2 font-Font1 text-[black]"
            >
              Clear ALL            </button>
            <button
              onClick={handleSelectAllChange}
              className={`rounded py-2 text-[12px] font-inter px-2  transition duration-300 ease-in-out  bg-[black] text-[#FFFFFF]`}
            >
              Apply Filters
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default FilterPopup;
